<template>
    <div class="skel">
        <header class="skel--header"/>

        <main class="skel--main">
            <router-view/>
        </main>

        <footer class="skel--footer"/>
    </div>
</template>

<script>
    export default {};
</script>
